export default "__VITE_ASSET__CM2bYR0y__"